// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container {
  background: rgba(21, 57, 122, 0.6);
  width: 21.333rem;
  padding: 1rem 2rem;
}
.container .text-title {
  color: white;
  font-weight: bold;
  font-size: 1rem;
  letter-spacing: 0;
  line-height: 1.375rem;
  text-shadow: 0 0.167rem 0 0 rgba(0, 0, 0, 0.24);
  margin-bottom: 0.875rem;
}
.container .text-subtitle {
  color: white;
  margin-top: 1rem;
  font-size: 1rem;
  font-weight: bold;
  letter-spacing: 0;
  line-height: 1rem;
  margin-bottom: 0.708rem;
}
.container .dFlex {
  display: flex;
  justify-content: center;
}

.countries .title {
  margin-left: 0.333rem;
  font-weight: bold;
}

.population {
  color: var(--color-yellow-bookmark);
}
.population .title {
  margin-left: 0.333rem;
  font-weight: bold;
}

.main-title {
  margin-bottom: 0.583rem;
}

.conditions {
  display: flex;
  justify-content: center;
  align-items: center;
}

.text-box {
  border-radius: 0.333rem;
  background: var(--color-light-blue) linear-gradient(0deg, rgba(255, 255, 255, 0) 0%, #FFFFFF 100%);
  min-height: 3.333rem;
  padding: 0.333rem;
  color: var(--color-primary-blue);
  margin-bottom: 0.667rem;
}
.text-box .text {
  font-size: 1rem;
  line-height: 1.333rem;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
}
.text-box .text .title {
  color: #003399;
  font-size: 1rem;
  font-weight: 500;
  letter-spacing: 0;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  height: 1.5rem;
  overflow-y: auto;
  width: 100%;
}
.text-box .text .subtitle {
  font-size: 1rem;
  font-weight: bold;
  letter-spacing: 0;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  height: 1.5rem;
  max-height: 2.5rem;
  overflow-y: auto;
  width: 100%;
}

.dimension-number {
  background: var(--color-yellow-bookmark) linear-gradient(0deg, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 0.48) 100%);
  font-size: 0.667rem;
  font-weight: bold;
  padding: 0.1rem 0.25rem;
  border-radius: 50%;
  position: absolute;
  height: auto;
}`, "",{"version":3,"sources":["webpack://./src/app/game/voting/voting-sidebar/voting-sidebar.component.scss"],"names":[],"mappings":"AAAA;EACE,kCAAA;EACA,gBAAA;EACA,kBAAA;AACF;AACE;EACE,YAAA;EACA,iBAAA;EACA,eAAA;EACA,iBAAA;EACA,qBAAA;EACA,+CAAA;EACA,uBAAA;AACJ;AAEE;EACE,YAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,iBAAA;EACA,iBAAA;EACA,uBAAA;AAAJ;AAGE;EACE,aAAA;EACA,uBAAA;AADJ;;AAME;EACE,qBAAA;EACA,iBAAA;AAHJ;;AAOA;EACE,mCAAA;AAJF;AAME;EACE,qBAAA;EACA,iBAAA;AAJJ;;AAQA;EACE,uBAAA;AALF;;AAQA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;AALF;;AAQA;EACE,uBAAA;EACA,kGAAA;EACA,oBAAA;EACA,iBAAA;EACA,gCAAA;EACA,uBAAA;AALF;AAOE;EACE,eAAA;EACA,qBAAA;EACA,4BAAA;EACA,qBAAA;EACA,gBAAA;AALJ;AAOI;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,oBAAA;EACA,4BAAA;EACA,cAAA;EACA,gBAAA;EACA,WAAA;AALN;AAQI;EACE,eAAA;EACA,iBAAA;EACA,iBAAA;EACA,oBAAA;EACA,4BAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;EACA,WAAA;AANN;;AAWA;EACE,yHAAA;EACA,mBAAA;EACA,iBAAA;EACA,uBAAA;EACA,kBAAA;EACA,kBAAA;EACA,YAAA;AARF","sourcesContent":[".container {\n  background: rgba(21, 57, 122, 0.6);\n  width: 21.333rem;\n  padding: 1rem 2rem;\n\n  .text-title {\n    color: white;\n    font-weight: bold;\n    font-size: 1rem;\n    letter-spacing: 0;\n    line-height: 1.375rem;\n    text-shadow: 0 0.167rem 0 0 rgba(0, 0, 0, 0.24);\n    margin-bottom: 0.875rem;\n  }\n\n  .text-subtitle {\n    color: white;\n    margin-top: 1rem;\n    font-size: 1rem;\n    font-weight: bold;\n    letter-spacing: 0;\n    line-height: 1rem;\n    margin-bottom: 0.708rem;\n  }\n\n  .dFlex {\n    display: flex;\n    justify-content: center;\n  }\n}\n\n.countries {\n  .title {\n    margin-left: 0.333rem;\n    font-weight: bold;\n  }\n}\n\n.population {\n  color: var(--color-yellow-bookmark);\n\n  .title {\n    margin-left: 0.333rem;\n    font-weight: bold;\n  }\n}\n\n.main-title {\n  margin-bottom: 0.583rem;\n}\n\n.conditions {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.text-box {\n  border-radius: 0.333rem;\n  background: var(--color-light-blue) linear-gradient(0deg, rgba(255, 255, 255, 0) 0%, #FFFFFF 100%);\n  min-height: 3.333rem;\n  padding: 0.333rem;\n  color: var(--color-primary-blue);\n  margin-bottom: 0.667rem;\n\n  .text {\n    font-size: 1rem;\n    line-height: 1.333rem;\n    -webkit-box-orient: vertical;\n    -webkit-line-clamp: 2;\n    overflow: hidden;\n\n    .title {\n      color: #003399;\n      font-size: 1rem;\n      font-weight: 500;\n      letter-spacing: 0;\n      display: -webkit-box;\n      -webkit-box-orient: vertical;\n      height: 1.5rem;\n      overflow-y: auto;\n      width: 100%;\n    }\n\n    .subtitle {\n      font-size: 1rem;\n      font-weight: bold;\n      letter-spacing: 0;\n      display: -webkit-box;\n      -webkit-box-orient: vertical;\n      height: 1.5rem;\n      max-height: 2.5rem;\n      overflow-y: auto;\n      width: 100%;\n    }\n  }\n}\n\n.dimension-number {\n  background: var(--color-yellow-bookmark) linear-gradient(0deg, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 0.48) 100%);\n  font-size: 0.667rem;\n  font-weight: bold;\n  padding: 0.1rem 0.25rem;\n  border-radius: 50%;\n  position: absolute;\n  height: auto;\n}\n\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
